<template>
  <v-card flat>
    <v-card-title class="card-bg-2" :id="`step-${index}`">
      <div class="headline pb-0" :class="{ 'grey--text': disabled }" style="align-items: baseline; display: flex;">
        Time Series
        <v-menu v-model="showHelp" offset-y open-on-hover :open-delay="400">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="showHelp = true" class="clickable ml-2" color="primary">
              info_outline
            </v-icon>
          </template>
          <v-card>
            <v-card-text> The time series shown are the time series from all selected stations within the selected date range.
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
      <!-- <v-spacer />
      <v-text-field :disabled="disabled" prepend-inner-icon="search" v-model="search" class="rounded font-weight-regular emphasize-clear" hide-details clearable @click:clear="clearSearch()" solo @keyup.enter="toggleCurrentTimeSeries()" placeholder="Search time series">
      </v-text-field> -->
    </v-card-title>
    <!-- <ShowTimeSeries ref="showTimeSeries" @timeSeries="selectedAnalytes = $event" :allTimeSeries="allTimeSeries" :timeSeries="timeSeries" :selection="selection" :search="search" :disabled="disabled" /> -->
    <!-- <ShowTimeSeries ref="showTimeSeries" :allTimeSeries="allTimeSeries" :timeSeries="selectedTimeSeries" :search="search" :disabled="disabled" /> -->
    <v-card-text class="card-bg-2 pa-0 default-border-bottom scroll-border-bottom">    
    <v-layout class="default-border-bottom scroll-border-bottom">
      <v-flex>
        <v-item-group mandatory v-model="filterToggle" active-class="white--text">
          <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
          <v-item>
            <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">Available</v-chip>
          </v-item>
          <v-item>
            <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
              <div style="float: left;" class="pr-2" :class="{ 'info--text font-weight-bold': selectedTimeSeries.length > 0 }">
                {{ selectedTimeSeries.length }}</div>
              Selected
            </v-chip>
          </v-item>
        </v-item-group>
      </v-flex>
      <v-spacer />
      <v-flex class="pr-2"></v-flex>
    </v-layout>    
    <v-data-table class="analytes-table" :class="{ 'five-items': pagination.rowsPerPage === 5, 'ten-items': pagination.rowsPerPage === 10, 'twenty-five-items': pagination.rowsPerPage === 25 }" ref="timeSeriesTable" v-model="selectedTimeSeries" :search="search" select-all :disabled="disabled" :headers="headers" :items="allTimeSeries" :pagination.sync="pagination" :item-key="selectionKey" :custom-filter="customFilter">
      <template v-slot:no-data>
        <div class="pa-4 text-xs-center">
          <v-icon color="warning">warning</v-icon>
          <br />
          No matching time series found
        </div>
      </template>
      <template v-slot:no-results>
        <div class="pa-4 text-xs-center">
          <v-icon color="warning">warning</v-icon>
          <br />
          No matching series found
        </div>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :disabled="filterToggle == filterToggles.unavailable || disabled" color="primary" :headers="headers" :item-key="selectionKey" class="analyteTable" :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.stop="toggleAll()"></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text" :class="[
              'column', header.sortable && 'sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]" @click="changeSort(header.sortable, header.value)">
            <v-icon small v-if="header.sortable">arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="toggleRow(props)" :class="{ 'clickable': (!isUnavailable(props.item) || props.selected) && !disabled }">
          <td>
            <v-checkbox color="primary" class="clickable" :disabled="isUnavailable(props.item)" :input-value="props.selected" primary hide-details></v-checkbox>            
          </td>
          <td class="text-xs-center">
            {{ props.item.LocationName }}
          </td>
          <td class="text-xs-center">
            {{ props.item.DisplayName }}
          </td>          
          <td class="text-xs-center">
            {{ formatDisplayDate(props.item.FirstRecordDate) }}
          </td>
          <td class="text-xs-center">
            {{ formatDisplayDate(props.item.LastRecordDate) }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
  </v-card>
</template>

<script>
  // import ShowTimeSeries from './ShowTimeSeries'
  import {
    formatDate,
    prettyDateTimeFormat,
  } from '@/components/mixins/MomentUtil'

  // import {
  //   customSearcher,
  //   getObjectValues,
  // } from '@/helpers/search'

  import {
    mergeDistinctObjectArrays,
  } from '@/helpers/arrays'

  import {
    defaultTableSorter,
    objectSorter,
    stringSorter,
    datetimeSorter,
    // numberSorter,
  } from '@/helpers/sorting'

  const filterToggles = {
    available: 0,
    selected: 1,
    unavailable: 2,
    all: -1,
  }

  const itemKey = 'TimeSeriesId'
  // const searchKey = 'DisplayName'

  export default {
    components: {
      //ShowTimeSeries,
    },
    props: {
      allTimeSeries: Array,
      timeSeries: Object,
      selection: Object,
      index: Number,
      disabled: Boolean,
      selectedStationIds: [],
    },
    data() {
      return {
        showHelp: false,
        search: '',
        selectedTimeSeries: [],
        selectionKey: itemKey,
        pagination: {
          sortBy: 'LocationName',
          rowsPerPage: 10,
          page: 1,
        },
        filterToggles,
        filterToggle: filterToggles.available,        
        itemsMetadata: [],
        showAnalyteName: false,
        
      }
    },
    computed: {
      headers() {
        return [
          {
            text: 'Location',
            align: 'center',
            sortable: true,
            value: 'LocationName',
            sorter: objectSorter('LocationName', stringSorter),
          },
          {
            text: 'Time Series',
            align: 'center',
            sortable: true,
            value: 'DisplayName',
            sorter: objectSorter('DisplayName', stringSorter),
          },
          {
            text: 'First Record',
            align: 'center',
            sortable: false,
            value: 'FirstRecordDate',
            sorter: objectSorter('FirstRecordDate', datetimeSorter),
          },
          {
            text: 'Last Record',
            align: 'center',
            sortable: false,
            value: 'LastRecordDate',
            sorter: objectSorter('LastRecordDate', datetimeSorter),
          },
        ]
      },
      availableTimeSeries() {
        return this.allTimeSeries.filter(timeSeries => !this.isUnavailable(timeSeries))
      },
      customSorter() {
        return defaultTableSorter(this.headers, this.pagination.sortBy, this.pagination.descending)
      },
    },
    watch: {
      selectedTimeSeries(value) {        
        this.emitUpdate(value)
      },
      
      filterToggle() {
        this.pagination.page = 1
      },
      selectedStationIds() {
        console.log(this.selectedStationIds)
      },
    },
    methods: {
      emitUpdate(value) {                
        this.$emit('changed', value)
      },
      clearSearch() {
        this.$nextTick(() => this.search = '')
      },
      toggleCurrentTimeSeries() {
        this.$refs.showTimeSeries.toggleCurrentTimeSeries()
      },
      isUnavailable(item) {
        if(this.selectedStationIds && this.selectedStationIds.length > 0) {
          var matched = (this.selectedStationIds.indexOf(item.LocationId) >= 0)
          return !matched
        } else {
          return false
        }
        // let key = item[itemKey]
        // let timeSeries = this.timeSeries[key]
        // return !timeSeries
      },
      customFilter() {
        let searchResult = this.allTimeSeries
        let result = []

        if (this.filterToggle == filterToggles.selected) {
          searchResult.forEach(item => {
            let index = this.selectedTimeSeries.findIndex(s => s[itemKey] === item[itemKey])
            if (index > -1) result.push(item)
          })
        } else if (this.filterToggle == filterToggles.available) {
          searchResult.forEach(item => {
            if (!this.isUnavailable(item)) {
              result.push(item)
            }
          })
        } else if (this.filterToggle == filterToggles.unavailable) {
          searchResult.forEach(item => {
            if (this.isUnavailable(item)) {
              result.push(item)
            }
          })
        } else {
          result = searchResult
        }

        return result
      },
      update() {
        this.selectedTimeSeries = []
      },
      toggleAll() {
        if (this.filterToggle != filterToggles.selected && this.selectedTimeSeries.length != this.availableTimeSeries.length) {
          this.selectedTimeSeries = this.availableTimeSeries
        } else {
          this.untoggleAll()
        }
      },
      untoggleAll() {
        this.selectedTimeSeries = []
      },
      toggleRow(props) {        
        if ((this.isUnavailable((props.item)) && !props.selected) || this.disabled) return
        props.selected = !props.selected
      },
      toggleCurrentAnalytes() {
        let filteredItems = this.$refs.timeSeriesTable.filteredItems
        this.selectedTimeSeries = mergeDistinctObjectArrays(
          this.selectedTimeSeries,
          filteredItems,
          this.selectionKey
        )
      },
      changeSort(sortable, column) {
        if (!sortable) return
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      formatDisplayDate(date) {
        return date ? formatDate(date, prettyDateTimeFormat) : ''
      },
    },
  }
</script>

<style>
  .clickable {
    cursor: pointer !important;
  }

  .switch {
    margin: 0 0 8px 0;
    padding: 0 0 0 14px;
    display: inline-block;
  }

  .switch>.v-input__control>.v-input__slot>label {
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  .chipFilter>.v-chip__content {
    cursor: pointer;
  }

  .analyteTable .theme--light.v-table tbody tr[active] {
    background: #f5f3ff;
  }

  .analytes-table.five-items>.v-table__overflow {
    min-height: 297px;
    background: #fafafa;
  }

  .analytes-table.ten-items>.v-table__overflow {
    min-height: 537px;
    background: #fafafa;
  }

  .analytes-table.twenty-five-items>.v-table__overflow {
    min-height: 1257px;
    background: #fafafa;
  }
</style>